import { getI18n } from "@editor/ui-utils";
const de = {
  redirectApi: {
    createAlreadyExists: "Redirect kann nicht erstellt werden, da bereits ein Redirect mit diesem Namen existiert",
    updateAlreadyExists: "Redirect kann nicht aktualisiert werden, da bereits ein Redirect mit diesem Namen existiert",
    created: "Redirect erstellt",
    updated: "Redirect aktualisiert",
    notFound: "Redirect nicht gefunden",
    requiredFields: "Sie können den Redirect nicht speichern, da obligatorische Informationen fehlen"
  },
  redirectList: {
    newButton: "Neues Redirect",
    name: "Suche nach Pfad",
    deleteRedirect: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade Redirect",
    headerLabel: "Bezeichnung",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    counter: "Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createRedirect: "Redirect erstellen"
  },
  redirect: {
    redirectLabel: "Redirect",
    backButton: "Zurück zur Redirect-Liste",
    newRedirect: "Neues Redirect",
    messageDeleteRedirect: "Redirect löschen",
    messageDeleteRedirectTitle: "Sind Sie sicher, dass Sie dieses Redirect löschen möchten?",
    deleteRedirect: "Löschen",
    messageDeleted: "Redirect gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des Redirects",
    errorFailedLoadedRedirectWithId: "Es gab einen Fehler beim Abrufen des Redirects",
    to: "Nach",
    from: "Von",
    comment: "Kommentar",
    invalidPathOrUrl: "Kein gültiger Pfad oder URL"
  },
  redirectEdit: {
    label: "Bezeichnung",
    counter: "Zähler",
    goToPage: "auf der Seite",
    backButton: "Zurück zur Redirect-Liste",
    editRedirect: "Redirect bearbeiten",
    messageSaved: "Neues Redirect gespeichert",
    deleteRedirect: "Redirect löschen"
  }
};
const en = {
  redirectApi: {
    createAlreadyExists: "Can't create Redirect because another Redirect with this name already exists",
    updateAlreadyExists: "Can't update Redirect because another Redirect with this name already exists",
    created: "Redirect created",
    updated: "Redirect updated",
    notFound: "Redirect not found",
    requiredFields: "You can't save the Redirect because mandatory information is missing"
  },
  redirectList: {
    newButton: "New Redirect",
    name: "Search by path",
    deleteRedirect: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading Redirect",
    headerLabel: "Label",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    counter: "Counter",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createRedirect: "Create Redirect"
  },
  redirect: {
    redirectLabel: "Redirect",
    backButton: "Back to Redirect list",
    newRedirect: "New Redirect",
    messageDeleteRedirect: "Delete Redirect",
    messageDeleteRedirectTitle: "Are you sure you want to delete this Redirect?",
    deleteRedirect: "Delete",
    messageDeleted: "Redirect Deleted",
    errorOnDeleting: "There was an error deleting the Redirect ",
    errorFailedLoadedRedirectWithId: "There was an error getting the Redirect",
    to: "To",
    from: "From",
    comment: "Comment",
    invalidPathOrUrl: "Is not valid path or URL"
  },
  redirectEdit: {
    label: "Label",
    counter: "Counter",
    goToPage: "To the page",
    backButton: "Back to Redirect list",
    editRedirect: "Edit Redirect",
    messageSaved: "New Redirect saved",
    deleteRedirect: "Delete redirect"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/redirect",
    children: [
      {
        path: "",
        name: "redirect_list",
        component: () => import("./redirect-list.view-BIYPKfTT.js"),
        meta: { requiredRight: "navigate_list_redirects_management" }
      },
      {
        path: "new",
        name: "redirect_new",
        component: () => import("./redirect-edit.view-DDDwGyGK.js"),
        props: () => ({
          title: getI18n().t("redirect.newRedirect"),
          backRoute: "/redirect"
        }),
        meta: { requiredRight: ["navigate_redirect_management"] }
      },
      {
        path: ":id",
        name: "redirect_detail",
        component: () => import("./redirect-edit.view-DDDwGyGK.js"),
        props: (route) => ({
          title: getI18n().t("redirectEdit.editRedirect"),
          id: route.params.id,
          backRoute: "/redirect"
        }),
        meta: { requiredRight: ["navigate_redirect_management"] }
      }
    ]
  }
];
const redirectModule = {
  messages,
  routes,
  contentBlocks: []
};
export {
  redirectModule
};
//# sourceMappingURL=index.es.js.map
